import React from 'react';

export function Loader() {
  return (
    <div className="section-loader">
      <span className="loader"></span>
    </div>
  );
}
